<template>
	<div>
		<div class="fixed" @click="handleClick">
			<img :src="fixInfo.iconUrl" alt />
		</div>
		<Cmask v-show="show">
			<div class="container" @click="close('dialog')" :style="dialogBgStyle">
				<div v-if="jumpType == 7" class="content">
				<div :style="fontStyle" v-html="formatText"></div>
				</div>
				<div class="line" v-if="[5, 7].includes(jumpType)">
				<span v-for="item in 5" :key="item"></span>
          <img
            class="close"
            :src="$closeIcon"
            @click.stop="close('close')"
            alt
          />
				</div>
			</div>
		</Cmask>
	</div>
</template>

<script>

export default {
  name: "fixLeft",
  props: {
    info: {
      type: Object,
      required: true,
    },
    activityId: {
      type: String,
      required: true
    },
    activityType: {
      type: Number,
      required: true
    },
    activityStatus: {
      type: Number,
      required: true
    }
  },
  inject: ['$closeIcon', 'getEnterSource'],
  data() {
    return {
      show: false, // 是否展示
      fixInfo: {}, // 悬浮框信息
      jumpType: undefined, // 跳转类型
    };
  },

  computed: {
    enterSource() {
      return this.getEnterSource();
    },
    dialogBgStyle() { // 判断dialog背景图片和显示大小
      let bgStyle = {};
      if ([5, 7].includes(this.jumpType)) {
        bgStyle = {
          padding: "50px 31px 37px",
          width: "309px",
          top: "50px",
          height: "390px",
          backgroundImage: `url(${
            this.jumpType == 5 ? this.fixInfo.dialogUrl : this.fixInfo.borderBgc
          })`,
        };
      } else if (this.jumpType == 6) {
        bgStyle = {
          width: "100vw",
          height: "418px",
          backgroundImage: `url(${this.fixInfo.topDialogUrl})`,
        };
      }
      return bgStyle;
    },
    formatText() {  // 文字\n 换成<br />
      return this.fixInfo.text.replace(/\n/g, "<br />");
    },
    fontStyle() {
      return {
        "font-size": this.fixInfo.fontSize / 2 + "px",
        color: this.fixInfo.color,
        "font-style": this.fixInfo.fontFontStyle.includes("italic")
          ? "italic"
          : "",
        "font-weight": this.fixInfo.fontFontStyle.includes("bold")
          ? "bold"
          : "",
        "text-stroke": `1px ${this.fixInfo.fontBoxShadow}`,
      };
    },
  },
  created() {},
  mounted() {
    this.formatData();
  },

  methods: {
    formatData() {
      this.fixInfo = this.info.baseConfig;
      this.jumpType = this.info.baseConfig.jumpType;
    },
    close(str) {
      if (str == "dialog") {
        if (this.jumpType == 6) {
          this.show = false;
        } else {
          console.log("无反应");
        }
      } else {
        this.show = false;
      }
    },
    handleClick() {
      // try {
      //   TDAPP.onEvent(`悬浮${this.info.key}`, `左悬浮按钮`);
      // } catch (e) {
      //   console.log("打点失败", e);
      // }
      this.defer(
        () => {
          this.$log.senLog({
              pointID: '12010005',
              eventType: 2,
              businessData: {
                  activityType: this.activityType !== undefined ? this.activityType : '',
                  activityId: this.activityId || '',
                  enterSource: this.enterSource,
              }
          })
        },
        () => {
          if ([5, 6, 7].includes(this.jumpType)) {
            this.show = true;
          } else {
            this.$emit("handleFixClick", this.fixInfo);
          }
        },
        300
      )
    },
  },
};
</script>

<style lang="scss" scoped>
.fixed {
  width: 138px;
  height: 60px;
  top: 30px;
  left: 0;
  z-index: 3;
  overflow: hidden;
  img {
    width: 100%;
  }
}
.container {
  z-index: 1000;
  position: absolute;
  left: 50%;
  background-size: 100% 100% !important;
  box-sizing: border-box;
  transform: translateX(-50%);
  display: flex;
  .content {
    flex: 1;
    box-sizing: border-box;
    overflow-y: auto;
    padding: 10px 20px;
    div {
      word-wrap: break-word;
      word-break: break-all;
    }
  }
  .line {
    position: absolute;
    bottom: -90px;
    left: 50%;
    transform: translateX(-50%);
    width: 2px;
    height: 90px;
    display: flex;
    flex-direction: column;
    span {
      width: 4px;
      height: 10px;
      margin-top: 7px;
      background: #fff;
    }
  }
  .close {
    position: absolute;
    width: 80px;
    height: 80px;
    bottom: -84px;
    left: 50%;
    color: #fff;
    transform: translateX(-50%);
  }
}
</style>
